var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-box",class:{'is-active': _vm.activeComp, 'inline-box': _vm.isInline},attrs:{"data-id":_vm.uuid},on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/ComponentBox/ComponentBox.vue